import type { IArticleWithOptions } from "@/data/commands/customer/AddArticleToCartCmd";
import type {
    ICustomerArticleWithOptions,
    ICustomerOptionGroup,
    ICustomerOptionGroupOption,
} from "@/data/model/Customer";

// main article
export function getPreselectedOptions(articleWithOptions: ICustomerArticleWithOptions): IArticleWithOptions[] {
    const selectedOptions = [] as IArticleWithOptions[];

    for (const optionGroup of articleWithOptions.options) {
        const selectedArticlesWithOptions = mapOptionGroup(optionGroup);
        for (const selectedArticle of selectedArticlesWithOptions) {
            selectedOptions.push(selectedArticle);
        }
    }

    return selectedOptions;
}

// option group
function mapOptionGroup(optionGroup: ICustomerOptionGroup): IArticleWithOptions[] {
    const result = [] as IArticleWithOptions[];

    for (const selectedOption of optionGroup.options) {
        if (!selectedOption.preselected) continue;

        result.push(mapOption(selectedOption, optionGroup.optionGroupId));
    }

    return result;
}

// option
function mapOption(option: ICustomerOptionGroupOption, optionGroupId: string): IArticleWithOptions {
    const entry: IArticleWithOptions = {
        quantity: option.minQuantity ?? 1,
        menuCategoryId: undefined,
        articleId: option.articleId,
        optionGroupId: optionGroupId,
        options: [],
    };

    for (const optionGroup of option.optionGroups) {
        const selectedArticlesWithOptions = mapOptionGroup(optionGroup);
        for (const selectedOption of selectedArticlesWithOptions) {
            entry.options.push(selectedOption);
        }
    }

    return entry;
}
